import React from "react";
import "./MeaTime.css";
const MeaTime = () => {
  return (
    <div className="meaTimeContainer">
      <h3>Total time to get MEA Apostille in Bangalore:</h3>
      <p>
        The overall time required for MEA Apostille in Bangalore for
        Certificates is based on several aspects such as which country you need
        the legalization for, or the organization you need it from, or the types
        of documents. Usually, it will take about seven to ten working days for
        completion. If the HRD is incorporated, the process may extend up to a
        couple of weeks more than a month.
      </p>
    </div>
  );
};

export default MeaTime;
